import './styles/main.scss';
import './styles/modern-ui.scss';
import modernMarkup from './templates/modern-body.html?raw';
import { initLegacyApp } from './legacy-app.js';

console.log('[MetaCreatures] 🚀 Инициализация приложения...', {
  userAgent: navigator.userAgent,
  hasTelegram: !!window.Telegram,
  hasWebApp: !!(window.Telegram && window.Telegram.WebApp),
  pathname: window.location.pathname,
  timestamp: new Date().toISOString()
});

// Game-режим удален - используем единый Mini App режим
// Скрытие навигации можно добавить через CSS при необходимости
if (false) { // Отключено - game-режим удален
  // Добавляем класс сразу
  document.documentElement.classList.add('game-mode');
  document.body.classList.add('game-mode');
  
  // Скрываем навигацию при загрузке DOM
  const hideNav = () => {
    // Скрываем нашу навигацию
    const navs = document.querySelectorAll('.modern-nav');
    console.log('[MetaCreatures] 🎮 Hiding navigation, found:', navs.length);
    navs.forEach(nav => {
      if (nav) {
        nav.style.display = 'none';
        nav.style.visibility = 'hidden';
        console.log('[MetaCreatures] 🎮 Navigation hidden');
      }
    });
    
    // Скрываем элементы Telegram WebApp навигации
    const telegramNavs = document.querySelectorAll('[class*="tgme"], [id*="telegram"], .tgme_widget_message_bubble');
    telegramNavs.forEach(nav => {
      if (nav) {
        nav.style.display = 'none';
        nav.style.visibility = 'hidden';
        nav.style.opacity = '0';
        nav.style.height = '0';
        nav.style.overflow = 'hidden';
      }
    });
    
    // Скрываем скроллбары глобально
    document.documentElement.style.scrollbarWidth = 'none';
    document.documentElement.style.overflow = 'hidden';
    document.body.style.scrollbarWidth = 'none';
    document.body.style.overflow = 'hidden';
    
    // Для WebKit браузеров
    const style = document.createElement('style');
    style.textContent = `
      html.game-mode, html.game-mode * {
        scrollbar-width: none !important;
        -ms-overflow-style: none !important;
      }
      html.game-mode::-webkit-scrollbar,
      html.game-mode *::-webkit-scrollbar {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideNav);
  } else {
    hideNav();
  }
  
  // Также скрываем после полной загрузки (на случай, если навигация рендерится позже)
  window.addEventListener('load', () => {
    setTimeout(hideNav, 500);
    setTimeout(hideNav, 1000);
    setTimeout(hideNav, 2000);
  });
  
  // Постоянно проверяем и скрываем навигацию Telegram
  setInterval(() => {
    const telegramNavs = document.querySelectorAll('[class*="tgme"], [id*="telegram"]');
    if (telegramNavs.length > 0) {
      telegramNavs.forEach(nav => {
        nav.style.display = 'none';
        nav.style.visibility = 'hidden';
      });
    }
  }, 1000);
}

// Расширяем Telegram WebApp на весь экран (поддержка вертикальной и горизонтальной ориентации)
function expandWebApp() {
  if (window.Telegram && window.Telegram.WebApp) {
    try {
      const webApp = window.Telegram.WebApp;
      
      // Сначала вызываем ready(), затем expand()
      if (!webApp.isReady) {
        webApp.ready();
      }
      
      // Принудительно расширяем на весь экран (работает в обеих ориентациях)
      webApp.expand();
      webApp.enableClosingConfirmation = false;
      
      // setHeaderColor и setBackgroundColor доступны только в версии 6.1+
      const version = parseFloat(webApp.version || '0');
      if (version >= 6.1) {
        webApp.setHeaderColor('#0F0F1A');
        webApp.setBackgroundColor('#0F0F1A');
      }
      
      // Определяем текущую ориентацию
      const isLandscape = window.innerWidth > window.innerHeight;
      const orientation = isLandscape ? 'landscape' : 'portrait';
      
      // Проверяем статус расширения
      const isExpanded = webApp.isExpanded;
      console.log('[MetaCreatures] ✅ Telegram WebApp расширен на весь экран', {
        isExpanded,
        orientation,
        viewportWidth: webApp.viewportWidth || window.innerWidth,
        viewportHeight: webApp.viewportHeight || window.innerHeight,
        viewportStableHeight: webApp.viewportStableHeight,
        platform: webApp.platform,
        version: webApp.version,
        screenWidth: window.screen.width,
        screenHeight: window.screen.height
      });
      
      // Обновляем CSS класс для ориентации
      document.documentElement.classList.toggle('orientation-landscape', isLandscape);
      document.documentElement.classList.toggle('orientation-portrait', !isLandscape);
      
      // Обработка события изменения viewport (включая изменение ориентации)
      if (webApp.onEvent) {
        webApp.onEvent('viewportChanged', () => {
          const newIsLandscape = window.innerWidth > window.innerHeight;
          const newOrientation = newIsLandscape ? 'landscape' : 'portrait';
          
          console.log('[MetaCreatures] 📐 Viewport changed, re-expanding...', {
            orientation: newOrientation,
            viewportWidth: webApp.viewportWidth || window.innerWidth,
            viewportHeight: webApp.viewportHeight || window.innerHeight,
            viewportStableHeight: webApp.viewportStableHeight
          });
          
          // Обновляем CSS класс для ориентации
          document.documentElement.classList.toggle('orientation-landscape', newIsLandscape);
          document.documentElement.classList.toggle('orientation-portrait', !newIsLandscape);
          
          // Повторно расширяем при изменении viewport
          setTimeout(() => {
            try {
              webApp.expand();
            } catch (e) {
              console.warn('[MetaCreatures] ⚠️ Ошибка при повторном расширении:', e);
            }
          }, 100);
        });
      }
      
    } catch (error) {
      console.warn('[MetaCreatures] ⚠️ Ошибка расширения WebApp:', error);
    }
  }
}

// Вызываем сразу и после загрузки
expandWebApp();
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', expandWebApp);
} else {
  setTimeout(expandWebApp, 100);
}

// Также вызываем при полной загрузке страницы
window.addEventListener('load', () => {
  setTimeout(expandWebApp, 200);
});

// Обработка изменения размера окна (для десктопных версий Telegram)
window.addEventListener('resize', () => {
  setTimeout(expandWebApp, 100);
});

// Обработка изменения ориентации экрана
window.addEventListener('orientationchange', () => {
  console.log('[MetaCreatures] 📱 Orientation changed, re-expanding...');
  // Даем время на завершение поворота экрана
  setTimeout(expandWebApp, 300);
  // Дополнительная проверка после полного поворота
  setTimeout(expandWebApp, 600);
});

// Также обрабатываем через matchMedia для более надежного определения
if (window.matchMedia) {
  const mediaQuery = window.matchMedia('(orientation: landscape)');
  const handleOrientationChange = (e) => {
    console.log('[MetaCreatures] 📐 Orientation media query changed:', e.matches ? 'landscape' : 'portrait');
    setTimeout(expandWebApp, 300);
  };
  mediaQuery.addEventListener('change', handleOrientationChange);
  
  // Инициализируем при загрузке
  handleOrientationChange(mediaQuery);
}

// Обработка ошибок из Telegram WebApp SDK (Solid.js)
window.addEventListener('error', function(e) {
  // Игнорируем ошибки из peerProfile.tsx и solid.js (это внутренний код SDK)
  const filename = e.filename || e.source || '';
  const message = e.message || '';
  const stack = e.error?.stack || '';
  
  if (filename.includes('peerProfile.tsx') || 
      filename.includes('solid.js') ||
      message.includes('Cannot access') && (stack.includes('peerProfile') || stack.includes('solid.js')) ||
      stack.includes('peerProfile.tsx') ||
      stack.includes('solid.js:')) {
    console.warn('[Telegram SDK] Игнорируем ошибку из SDK:', message);
    e.preventDefault();
    e.stopPropagation();
    return true;
  }
}, true);

// Также обрабатываем unhandledrejection для Promise ошибок
window.addEventListener('unhandledrejection', function(e) {
  const reason = e.reason || {};
  const stack = reason.stack || '';
  const message = reason.message || String(reason);
  
  if (stack.includes('peerProfile.tsx') || 
      stack.includes('solid.js') ||
      message.includes('Cannot access') && (stack.includes('peerProfile') || stack.includes('solid.js'))) {
    console.warn('[Telegram SDK] Игнорируем Promise rejection из SDK:', message);
    e.preventDefault();
    e.stopPropagation();
    return true;
  }
});

// ВАЖНО: Блокируем все API запросы СРАЗУ, до любой инициализации
if (!window.__originalFetch) {
  window.__originalFetch = window.fetch;
}

window.fetch = function(...args) {
  const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
  
  // Разрешаем только статические ресурсы
  if (url && (
    url.includes('/assets/') ||
    url.includes('.css') ||
    url.includes('.js') ||
    url.match(/\.(png|jpg|jpeg|svg|woff|woff2|ttf|ico)$/i)
  )) {
    return window.__originalFetch.apply(this, args);
  }
  
  // Блокируем все API запросы до проверки доступа
  if (!window.__accessGranted) {
    // Логируем только в режиме отладки
    if (localStorage.getItem('debug') === 'true' || new URLSearchParams(window.location.search).get('debug') === 'true') {
      console.warn('[MetaCreatures] Blocked API request:', url);
    }
    return Promise.resolve(new Response(
      JSON.stringify({
        success: false,
        error: 'access_denied',
        message: 'Доступ ограничен'
      }),
      {
        status: 403,
        statusText: 'Forbidden',
        headers: { 'Content-Type': 'application/json' }
      }
    ));
  }
  
  // Если доступ разрешен - используем оригинальный fetch
  return window.__originalFetch.apply(this, args);
};

console.log('[MetaCreatures] 🔒 API requests blocked until access check');

// Функция для загрузочного экрана
function setupLoadingScreen() {
  const loadingScreen = document.getElementById('loadingScreen');
  const progressElement = document.getElementById('loadingProgress');
  const textElement = document.getElementById('loadingText');
  
  if (!loadingScreen || !progressElement || !textElement) {
    console.warn('[MetaCreatures] ⚠️ Элементы загрузочного экрана не найдены');
    return;
  }
  
  let progress = 0;
  let progressComplete = false;
  let appInitialized = false;
  
  // Функция для проверки готовности скрыть экран
  function checkReadyToHide() {
    if (progressComplete && appInitialized) {
      setTimeout(() => {
        hideLoadingScreen();
      }, 500);
    }
  }
  
  // Сохраняем флаг готовности в глобальной области
  window.__loadingProgressComplete = false;
  window.__appInitialized = false;
  window.__checkLoadingComplete = function() {
    if (window.__loadingProgressComplete && window.__appInitialized) {
      setTimeout(() => {
        hideLoadingScreen();
      }, 500);
    }
  };
  
  const interval = setInterval(() => {
    progress += 2;
    if (progressElement) {
      progressElement.style.width = progress + '%';
    }
    
    if (progress <= 25) {
      if (textElement) textElement.textContent = 'Загрузка ресурсов...';
    } else if (progress <= 50) {
      if (textElement) textElement.textContent = 'Инициализация глитчлингов...';
    } else if (progress <= 75) {
      if (textElement) textElement.textContent = 'Подключение к серверу...';
    } else {
      if (textElement) textElement.textContent = 'Почти готово...';
    }
    
    if (progress >= 100) {
      clearInterval(interval);
      progressComplete = true;
      window.__loadingProgressComplete = true;
      // Проверяем, можно ли скрыть экран
      checkReadyToHide();
      window.__checkLoadingComplete();
    }
  }, 160); // Увеличено до 160 мс (в 4 раза медленнее от оригинала)
}

function hideLoadingScreen() {
  const loadingScreen = document.getElementById('loadingScreen');
  if (loadingScreen) {
    loadingScreen.classList.add('fade-out');
    setTimeout(() => {
      loadingScreen.style.display = 'none';
    }, 500);
  }
}

// Экспортируем функцию для использования в других местах
window.hideLoadingScreen = hideLoadingScreen;

const root = document.getElementById('app');

if (!root) {
  console.error('[MetaCreatures] ❌ #app container не найден');
} else {
  console.log('[MetaCreatures] ✅ #app container найден, загружаем разметку...');
  root.innerHTML = modernMarkup;
  console.log('[MetaCreatures] ✅ Разметка загружена, инициализируем загрузочный экран...');
  
  // Game-режим удален - используем единый Mini App режим
  console.log('[MetaCreatures] 📱 Mini App mode');
  
  // Инициализация загрузочного экрана
  setupLoadingScreen();
  
  // Инициализация приложения после загрузки
  setTimeout(async () => {
  try {
      await initLegacyApp();
    console.log('[MetaCreatures] ✅ initLegacyApp вызван успешно');
      
      // Game-режим удален - home-screen показывается автоматически
      
      // Помечаем, что приложение инициализировано
      window.__appInitialized = true;
      // Проверяем, можно ли скрыть экран (только если прогресс тоже завершён)
      if (typeof window.__checkLoadingComplete === 'function') {
        window.__checkLoadingComplete();
      }
  } catch (error) {
    console.error('[MetaCreatures] ❌ Ошибка при вызове initLegacyApp:', error);
      // В случае ошибки всё равно скрываем экран
      window.__appInitialized = true;
      if (typeof window.__checkLoadingComplete === 'function') {
        window.__checkLoadingComplete();
      }
  }
  }, 400); // Увеличено до 400 мс (в 4 раза от оригинала）
}

// Управление fade-индикаторами скролла в стиле Brawl Stars
function initScrollFadeIndicators() {
  const updateScrollIndicators = (element) => {
    if (!element) return;
    
    const scrollTop = element.scrollTop;
    const scrollHeight = element.scrollHeight;
    const clientHeight = element.clientHeight;
    const canScrollUp = scrollTop > 10;
    const canScrollDown = scrollTop < scrollHeight - clientHeight - 10;
    
    element.classList.toggle('can-scroll-up', canScrollUp);
    element.classList.toggle('can-scroll-down', canScrollDown);
  };
  
  const setupScrollListeners = () => {
    const menus = document.querySelectorAll('.glitchlings-left-menu, .glitchlings-right-menu');
    menus.forEach(menu => {
      updateScrollIndicators(menu);
      
      menu.addEventListener('scroll', () => {
        updateScrollIndicators(menu);
      }, { passive: true });
      
      // Обновляем при изменении размера
      const resizeObserver = new ResizeObserver(() => {
        updateScrollIndicators(menu);
      });
      resizeObserver.observe(menu);
    });
  };
  
  // Запускаем после загрузки DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupScrollListeners);
  } else {
    setupScrollListeners();
  }
  
  // Также запускаем после инициализации приложения
  setTimeout(setupScrollListeners, 1000);
}

// Инициализируем fade-индикаторы
initScrollFadeIndicators();
